let staticToken = ''
export default {
  getToken (newToken = staticToken) {
    let authorization = newToken ? JSON.parse(decodeURIComponent(newToken)) : ''
    return authorization ? authorization.access_token : ''
  },
  setToken(newToken) { // 登录因为需要去进行跳转
    staticToken = newToken
  },
  async logout () {
    const res = await loginSdk.requestAction('clear_cookie')
    staticToken = ''
    return res.code
  },
  proxyInfo (callback) {
    const logHandler = {
      get: function (target, key) {
        if (key === 'inited') {
          if (target[key]) {
            callback()
          } else {
            let timer = setInterval(() => {
              if (target[key]) {
                timer = clearInterval(timer)
                loginSdk.requestAction('get_token').then((res) => {
                  staticToken = res
                  callback()
                })
              }
            }, 50)
          }
        }
      }
    }
    var act = new Proxy(window.loginSdk, logHandler)
    const inited = act.inited
  }
}